import { v7 as uuidV7 } from 'uuid';
import type { IdGenerator } from '@obraplan/core/application/ports/id-generator';
import type { Id } from '@obraplan/core/domain/shared/ids';

/**
 * Identificadores UUIDv7.
 *
 * Ordenáveis por tempo — o que dá localidade no índice do IndexedDB, permite paginação
 * por cursor e serve de base para uma futura sincronização entre dispositivos (ADR-101).
 * IDs sequenciais estão fora de questão: vazam volume de negócio.
 */
export class UuidV7Generator implements IdGenerator {
  next<B extends string>(): Id<B> {
    return uuidV7() as Id<B>;
  }
}
